export default function Hardware()
{
    return(
        <div className='Page'>
            <h1>Hardware</h1>
        </div>
    )
}